export default __webpack_public_path__ + "static/media/pause.97029c79.svg";